var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('v-footer',{staticClass:"footerpart",attrs:{"app":"","color":"white","inset":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+" — Росконгресс")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }